import React, { useEffect, useState } from 'react';

import _ from 'lodash';
import cx from 'classnames';
import { colorToString } from '../widget.helper';

import styles from './line.module.scss';
import {AnimationComponent} from '../../Animations';
import { HotspotTrigger } from '../../../components/hotspot';
import { getColorsConfig } from '../../../components/AssetViewer/helper/cssHelper';

const LineWidgetComponent = ({className, style, widgetProps, breakpoint}) => {
  const id = _.get(widgetProps, 'uid');

  const ref = React.useRef();

  const properties = _.get(widgetProps, `properties.${breakpoint}`);
  const defaultProperties = _.get(widgetProps, `properties.desktop`, {});
  const type = _.get(widgetProps, `properties.desktop.type`);
  const shapeAimation = _.get(widgetProps, `properties.${breakpoint}.animation`, {}) || {};

  const layout = _.get(defaultProperties, 'layout');
  const fillColor = _.get(defaultProperties, `fill`);
  const stroke = _.get(defaultProperties, `stroke`);
  const legacyStyle = _.get(defaultProperties, `legacyStyle`);
  
  let Styles = {
    ...style,
    marginTop: legacyStyle ? '10px': 'unset'
  }

  return (
    <HotspotTrigger widget={widgetProps} breakpoint={breakpoint} targetRef={ref}>
      <div id={id}
        ref={ref}
        className={cx(className, styles.lineWidget)}
        style={Styles}
        data-widget-id={id}
      >
        <AnimationComponent {...shapeAimation}>
          <Line
            type={type}
            fill={fillColor}
            stroke={stroke}
          />
        </AnimationComponent>
      </div>
    </HotspotTrigger>
  );
}

export const Line = ({ className, type, width, stroke, fill }) => {

  const fillColor = getColorsConfig(fill);
  const strokeColor = getColorsConfig(_.get(stroke, 'color'));
  const strokeWidth = parseInt(_.get(stroke, 'width', 0));

  const style = {
    fill: fillColor,
    borderTopColor: strokeColor,
    borderTopWidth: strokeWidth,
    borderTopStyle: type
  }

  return (
    <div className={cx(styles.line, className)} style={style}></div>
  );
}


const lineWidgetEquals = function(prevProps, nextProps){
  const paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const LineWidget = React.memo(LineWidgetComponent, lineWidgetEquals);
